export const PROFILES = [
  ["LinkedIn", "https://www.linkedin.com/in/jonesfreya/"],
  ["Entrepreneur Middle East author profile", "https://mena.entrepreneur.com/author/freya-jones"],
];

export const SPEAKING = [
  { title: "Five Psychological Tips to Help You Increase Conversion Rates in PPC", where: "PPC Live", url: "https://www.ppc.live/past-speakers/freya-jones" },
];

export const ARTICLES = [
  ["18 Tips To Make Your Marketing Efforts Soar In 2018", "https://mena.entrepreneur.com/marketing/18-tips-to-make-your-marketing-efforts-soar-in-2018/307118"],
  ["The How-To: Making Your Remarketing Campaign A Success", "https://mena.entrepreneur.com/growth-strategies/the-how-to-making-your-remarketing-campaign-a-success/301161"],
  ["Five Ways To Spruce Up Your Startup's Digital Marketing Efforts", "https://mena.entrepreneur.com/marketing/five-ways-to-spruce-up-your-startups-digital-marketing/299314"],
  ["I Got 99 Problems, But Leads Ain't One: Eight Tips For Generating Leads", "https://mena.entrepreneur.com/growth-strategies/i-got-99-problems-but-leads-aint-one-eight-tips-for/295199"],
  ["How To Rate Your Pay Per Click (PPC) Agency", "https://mena.entrepreneur.com/marketing/how-to-rate-your-pay-per-click-ppc-agency/288249"],
  ["10 Benefits Of Outsourcing Your Digital Marketing", "https://mena.entrepreneur.com/marketing/10-benefits-of-outsourcing-your-digital-marketing/286120"],
];

export const INTERVIEWS = [
  { title: "Freya Jones, Digital AdDoctor", where: "Brilliant Businesses", url: "https://brilliantbusinesses.biz/story/digital-addoctor-freya-jones/" },
  { title: "Interview With Freya (Founder at Digital AdDoctor)", where: "LinkedIn", url: "https://www.linkedin.com/pulse/interview-freya-founder-digital-addoctor-omar-reyes-isk0e" },
];

export const SAME_AS = PROFILES.map(([, u]) => u);
